export const FLOWER_TYPES = {
  SIMPLE: 'simple',
};

export const FLOWER_COLORS = [
  { 
    id: 0,
    name: 'Rose',
    petals: ['#D4696B', '#E88B8D', '#F2A8AA'], 
    center: '#8B3A3D', 
    leaf: '#7A9B6F',
    accent: '#F4C1C3' 
  },
  { 
    id: 1,
    name: 'Blue',
    petals: ['#5B8FA3', '#7DACC0', '#9BC5D9'], 
    center: '#2F4858', 
    leaf: '#6B8E7D',
    accent: '#B8D9E8' 
  },
  { 
    id: 2,
    name: 'Gold',
    petals: ['#E8B864', '#F4D699', '#F9E5BB'], 
    center: '#A67939', 
    leaf: '#8DAA7F',
    accent: '#FDF2D6' 
  },
  { 
    id: 3,
    name: 'Sage',
    petals: ['#9BB89F', '#B5D4BA', '#D1E8D5'], 
    center: '#5D7861', 
    leaf: '#6F8B73',
    accent: '#E5F4E8' 
  },
  { 
    id: 4,
    name: 'Lavender',
    petals: ['#B87B8E', '#D4A0B1', '#E8BFD0'], 
    center: '#7A4555', 
    leaf: '#7D9680',
    accent: '#F2D9E3' 
  },
];

export function getRandomFlowerColor() {
  return FLOWER_COLORS[Math.floor(Math.random() * FLOWER_COLORS.length)];
}

export function generateFlowerProperties(isFirstWord = false) {
  return {
    flower_type: FLOWER_TYPES.SIMPLE,
    flower_color_index: Math.floor(Math.random() * FLOWER_COLORS.length),
    rotation: (Math.random() - 0.5) * 25,
    scale: isFirstWord ? 2.2 : (1.3 + Math.random() * 0.5)
  };
}
